var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.selecionaCor,"label":"","text-color":_vm.corTexto}},[_c('v-icon',{staticClass:"pr-1",attrs:{"start":""}},[_vm._v("mdi-timer-sync-outline")]),_c('span',[_vm._v(_vm._s(_vm.titulo)+" ")]),_vm._v(" "+_vm._s(_vm.tempoExecucao)+" (s) ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }